import { TextareaAutosize, TextareaAutosizeProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import cls from "classnames";
import React, { useEffect, useState } from "react";

interface CountTextFieldProps extends TextareaAutosizeProps {
  maxLength?: number;
  title?: any | string;
  value?: string;
  name: string;
  placeHolder?: string;
  onChange?: (event: any) => void;
  className?: any;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      marginBottom: 18
    },
    displayFieldZone: {
      "& textarea": {
        background: "#F4F7FE"
      },
      "&:hover": {
        "& textarea": {
          background: "#FFF"
        },
        background: "#FFF",
        border: "solid 1px",
        borderColor: theme.palette.info.main,
        borderRadius: 4,
        boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.08)"
      },
      "&:focus-within": {
        borderColor: theme.palette.info.main,
        borderRadius: 4,
        boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.24)"
      },
      background: "#F4F7FE",
      padding: 10,
      border: "1px solid",
      borderColor: "#F4F7FE",
      borderRadius: 4
    },
    fieldZone: {
      "&:hover": {
        border: "solid 1px",
        borderColor: theme.palette.info.main,
        borderRadius: 4,
        boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.08)"
      },
      "&:focus-within": {
        borderColor: theme.palette.info.main,
        borderRadius: 4,
        boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.24)"
      },
      background: "#FFF",
      padding: 10,
      border: "solid 1px",
      borderColor: theme.palette.grey[400],
      borderRadius: 4
    },
    title: {
      marginBottom: 10,
      color: theme.palette.info.main,
      display: "flex",
      alignItems: "center",
      "& .MuiSvgIcon-root": {
        marginRight: 10
      }
    },
    count: {
      textAlign: "right",
      marginTop: 5,
      color: theme.palette.grey[700],
      fontSize: 12,
      lineHeight: "18px"
    },
    inputField: {
      resize: "none",
      width: "100%",
      color: theme.palette.grey[900],
      border: 0,
      fontSize: "1.4rem",
      "&:focus-visible": {
        outline: "none"
      },
      "&::placeholder": {
        color: theme.palette.grey[500],
        fontSize: "1.4rem"
      }
    }
  }),
  { name: "CountTextField" }
);

const CountTextField: React.FC<CountTextFieldProps> = ({
  maxLength = 250,
  title,
  value = "",
  name,
  onChange,
  onBlur,
  placeHolder,
  className,
  rowsMin,
  rowsMax,
  ...agrs
}) => {
  const classes = useStyles();
  const [textValue, setValue] = useState(value);
  const [isFocus, setFocus] = useState(false);
  const handleChange = value => {
    const textField = value.target.value;
    setValue(value.target.value);
    onChange?.({
      target: {
        value: textField,
        name
      }
    });
  };

  useEffect(() => {
    setValue(value);
  }, [value]);

  // SEO-222 requirements (pending)
  // const isDisplay = useMemo(() => {
  //   if (isFocus) {
  //     return false;
  //   }
  //   return !!value;
  // }, [isFocus, value]);
  //
  const handleFocus = () => {
    setFocus(true);
  };

  const handleOnBlur = event => {
    setFocus(false);
    onBlur?.(event);
  };

  return (
    <div className={cls(classes.root, className)}>
      {/* SEO-222, isDisplay ? classes.displayFieldZone : classes.fieldZone */}
      <div className={cls(classes.fieldZone, "fieldZone")}>
        {title ? <div className={classes.title}>{title}</div> : null}
        <TextareaAutosize
          {...agrs}
          value={textValue}
          onChange={handleChange}
          className={classes.inputField}
          rowsMax={rowsMax ?? 2}
          rowsMin={rowsMin ?? 2}
          placeholder={!isFocus ? placeHolder || "พิมพ์ที่นี่..." : ""}
          name={name}
          maxLength={maxLength}
          onFocus={handleFocus}
          onBlur={handleOnBlur}
        />
      </div>
      <div className={classes.count}>
        {textValue ? textValue.length : 0}/{maxLength}
      </div>
    </div>
  );
};

export default CountTextField;
